module.exports = __webpack_public_path__ + "img/case-1.d8ee48b.png";